import styled from '@emotion/styled';

export const YearLabel = styled.p`
  font-size: 12px;
  font-weight: 600;
  line-height: 24px;
  margin-right: 12px;
`;
